module.exports = __webpack_public_path__ + "images/canonical-comment/send-icon.5aa6a4fcc12bdee5957a.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-comment/send-icon.svg
// module id = WQU7
// module chunks = 2